import { useCallback, useState } from 'react';
export function useDriveItemModal() {
    const [config, setConfig] = useState(null);
    const open = useCallback((config, action) => {
        setConfig({ forwardConfig: config, action });
    }, []);
    const close = useCallback(() => setConfig(null), []);
    return [open, close, config];
}
